// material-ui
import { styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const StyledDatePicker = styled(DatePicker)`
  & .MuiInputAdornment-positionEnd {
    margin-right: 10px;
  }
`;
